import 'disposablestack/auto';

// @ts-expect-error ignore
Symbol.dispose ??= Symbol('Symbol.dispose');
// @ts-expect-error ignore
Symbol.asyncDispose ??= Symbol('Symbol.asyncDispose');
